//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v14.6.3.0 (NJsonSchema v11.5.2.0 (Newtonsoft.Json v13.0.0.0)) (http://NSwag.org)
// </auto-generated>
//----------------------

/* eslint-disable */
// ReSharper disable InconsistentNaming

import { HttpClient, HttpHeaders, HttpResponse, HttpResponseBase } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { Observable, of as _observableOf, throwError as _observableThrow } from 'rxjs';
import { catchError as _observableCatch, mergeMap as _observableMergeMap } from 'rxjs/operators';
import { AGENT_API_BASE_URL } from '../http/api-client.tokens';

export interface IClient {
  /**
   * Generates AI output for a clinical assessment.
   *
   * @param body (optional)
   * @returns OK
   */
  generate(
    assessmentId: number,
    body?: GenerateAssessmentAiRequest | undefined
  ): Observable<GenerateAssessmentAiResponse>;
  /**
   * Returns run history for an assessment.
   *
   * @param page (optional)
   * @param pageSize (optional)
   * @returns OK
   */
  runs(
    assessmentId: number,
    page?: number | undefined,
    pageSize?: number | undefined
  ): Observable<AssessmentAiRunSummaryResponsePagedResult>;
  /**
   * Returns full detail for a specific run.
   *
   * @returns OK
   */
  runs2(runId: number): Observable<GenerateAssessmentAiResponse>;
  /**
   * Generates an AI preview without recording a clinical run.
   *
   * @param body (optional)
   * @returns OK
   */
  generate2(body?: GeneratePreviewAiRequest | undefined): Observable<GenerateAssessmentAiResponse>;
  /**
   * Returns the AI configuration (feature toggle and prompt mapping) for a client.
   *
   * @returns OK
   */
  aiConfigGET(clientId: number): Observable<ClientAiConfigResponse>;
  /**
   * Saves the AI feature toggle and prompt library mapping for a client.
   *
   * @param body (optional)
   * @returns No Content
   */
  aiConfigPUT(clientId: number, body?: SaveClientAiConfigRequest | undefined): Observable<void>;
  /** @returns OK */
  health(): Observable<void>;
  /** @returns OK */
  detailed(): Observable<HealthCheckResponse>;
  /**
   * @param page (optional)
   * @param pageSize (optional)
   * @param search (optional)
   * @returns OK
   */
  promptLibrariesGET(
    page?: number | undefined,
    pageSize?: number | undefined,
    search?: string | undefined
  ): Observable<PromptLibraryResponsePagedResult>;
  /**
   * @param body (optional)
   * @returns No Content
   */
  promptLibrariesPOST(body?: SavePromptLibraryRequest | undefined): Observable<void>;
  /** @returns No Content */
  promptLibrariesGET2(id: number): Observable<void>;
  /**
   * @param body (optional)
   * @returns No Content
   */
  promptLibrariesPUT(id: number, body?: SavePromptLibraryRequest | undefined): Observable<void>;
  /**
   * @param body (optional)
   * @returns No Content
   */
  status(id: number, body?: UpdateStatusRequest | undefined): Observable<void>;
  /** @returns No Content */
  promptsGET(id: number): Observable<void>;
  /**
   * @param body (optional)
   * @returns No Content
   */
  promptsPOST(id: number, body?: SavePromptRequest | undefined): Observable<void>;
  /**
   * @param body (optional)
   * @returns No Content
   */
  promptsPUT(promptId: number, body?: SavePromptRequest | undefined): Observable<void>;
  /**
   * @param body (optional)
   * @returns No Content
   */
  status2(promptId: number, body?: UpdateStatusRequest | undefined): Observable<void>;
}

@Injectable()
export class Client implements IClient {
  protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

  private http = inject(HttpClient);
  private baseUrl = inject<string>(AGENT_API_BASE_URL);

  /**
   * Generates AI output for a clinical assessment.
   *
   * @param body (optional)
   * @returns OK
   */
  generate(
    assessmentId: number,
    body?: GenerateAssessmentAiRequest | undefined
  ): Observable<GenerateAssessmentAiResponse> {
    let url_ = this.baseUrl + '/api/Agent/assessments/{assessmentId}/generate';
    if (assessmentId === undefined || assessmentId === null)
      throw new globalThis.Error("The parameter 'assessmentId' must be defined.");
    url_ = url_.replace('{assessmentId}', encodeURIComponent('' + assessmentId));
    url_ = url_.replace(/[?&]$/, '');

    const content_ = JSON.stringify(body);

    let options_: any = {
      body: content_,
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        Accept: 'application/json',
      }),
    };

    return this.http
      .request('post', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processGenerate(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processGenerate(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<GenerateAssessmentAiResponse>;
            }
          } else return _observableThrow(response_) as any as Observable<GenerateAssessmentAiResponse>;
        })
      );
  }

  protected processGenerate(response: HttpResponseBase): Observable<GenerateAssessmentAiResponse> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
          ? (response as any).error
          : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result200: any = null;
          let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result200 = GenerateAssessmentAiResponse.fromJS(resultData200);
          return _observableOf(result200);
        })
      );
    } else if (status === 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return throwException('No Content', status, _responseText, _headers);
        })
      );
    } else if (status === 400) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result400: any = null;
          let resultData400 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result400 = ProblemDetails.fromJS(resultData400);
          return throwException('Bad Request', status, _responseText, _headers, result400);
        })
      );
    } else if (status === 401) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result401: any = null;
          let resultData401 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result401 = ProblemDetails.fromJS(resultData401);
          return throwException('Unauthorized', status, _responseText, _headers, result401);
        })
      );
    } else if (status === 403) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result403: any = null;
          let resultData403 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result403 = ProblemDetails.fromJS(resultData403);
          return throwException('Forbidden', status, _responseText, _headers, result403);
        })
      );
    } else if (status === 404) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result404: any = null;
          let resultData404 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result404 = ProblemDetails.fromJS(resultData404);
          return throwException('Not Found', status, _responseText, _headers, result404);
        })
      );
    } else if (status === 409) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result409: any = null;
          let resultData409 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result409 = ProblemDetails.fromJS(resultData409);
          return throwException('Conflict', status, _responseText, _headers, result409);
        })
      );
    } else if (status === 422) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result422: any = null;
          let resultData422 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result422 = ProblemDetails.fromJS(resultData422);
          return throwException('Unprocessable Content', status, _responseText, _headers, result422);
        })
      );
    } else if (status === 500) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return throwException('Internal Server Error', status, _responseText, _headers);
        })
      );
    } else if (status === 504) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return throwException('Gateway Timeout', status, _responseText, _headers);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        })
      );
    }
    return _observableOf(null as any);
  }

  /**
   * Returns run history for an assessment.
   *
   * @param page (optional)
   * @param pageSize (optional)
   * @returns OK
   */
  runs(
    assessmentId: number,
    page?: number | undefined,
    pageSize?: number | undefined
  ): Observable<AssessmentAiRunSummaryResponsePagedResult> {
    let url_ = this.baseUrl + '/api/Agent/assessments/{assessmentId}/runs?';
    if (assessmentId === undefined || assessmentId === null)
      throw new globalThis.Error("The parameter 'assessmentId' must be defined.");
    url_ = url_.replace('{assessmentId}', encodeURIComponent('' + assessmentId));
    if (page === null) throw new globalThis.Error("The parameter 'page' cannot be null.");
    else if (page !== undefined) url_ += 'page=' + encodeURIComponent('' + page) + '&';
    if (pageSize === null) throw new globalThis.Error("The parameter 'pageSize' cannot be null.");
    else if (pageSize !== undefined) url_ += 'pageSize=' + encodeURIComponent('' + pageSize) + '&';
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        Accept: 'application/json',
      }),
    };

    return this.http
      .request('get', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processRuns(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processRuns(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<AssessmentAiRunSummaryResponsePagedResult>;
            }
          } else return _observableThrow(response_) as any as Observable<AssessmentAiRunSummaryResponsePagedResult>;
        })
      );
  }

  protected processRuns(response: HttpResponseBase): Observable<AssessmentAiRunSummaryResponsePagedResult> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
          ? (response as any).error
          : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result200: any = null;
          let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result200 = AssessmentAiRunSummaryResponsePagedResult.fromJS(resultData200);
          return _observableOf(result200);
        })
      );
    } else if (status === 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return throwException('No Content', status, _responseText, _headers);
        })
      );
    } else if (status === 400) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result400: any = null;
          let resultData400 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result400 = ProblemDetails.fromJS(resultData400);
          return throwException('Bad Request', status, _responseText, _headers, result400);
        })
      );
    } else if (status === 401) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result401: any = null;
          let resultData401 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result401 = ProblemDetails.fromJS(resultData401);
          return throwException('Unauthorized', status, _responseText, _headers, result401);
        })
      );
    } else if (status === 403) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result403: any = null;
          let resultData403 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result403 = ProblemDetails.fromJS(resultData403);
          return throwException('Forbidden', status, _responseText, _headers, result403);
        })
      );
    } else if (status === 404) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result404: any = null;
          let resultData404 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result404 = ProblemDetails.fromJS(resultData404);
          return throwException('Not Found', status, _responseText, _headers, result404);
        })
      );
    } else if (status === 409) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result409: any = null;
          let resultData409 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result409 = ProblemDetails.fromJS(resultData409);
          return throwException('Conflict', status, _responseText, _headers, result409);
        })
      );
    } else if (status === 500) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return throwException('Internal Server Error', status, _responseText, _headers);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        })
      );
    }
    return _observableOf(null as any);
  }

  /**
   * Returns full detail for a specific run.
   *
   * @returns OK
   */
  runs2(runId: number): Observable<GenerateAssessmentAiResponse> {
    let url_ = this.baseUrl + '/api/Agent/runs/{runId}';
    if (runId === undefined || runId === null) throw new globalThis.Error("The parameter 'runId' must be defined.");
    url_ = url_.replace('{runId}', encodeURIComponent('' + runId));
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        Accept: 'application/json',
      }),
    };

    return this.http
      .request('get', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processRuns2(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processRuns2(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<GenerateAssessmentAiResponse>;
            }
          } else return _observableThrow(response_) as any as Observable<GenerateAssessmentAiResponse>;
        })
      );
  }

  protected processRuns2(response: HttpResponseBase): Observable<GenerateAssessmentAiResponse> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
          ? (response as any).error
          : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result200: any = null;
          let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result200 = GenerateAssessmentAiResponse.fromJS(resultData200);
          return _observableOf(result200);
        })
      );
    } else if (status === 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return throwException('No Content', status, _responseText, _headers);
        })
      );
    } else if (status === 400) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result400: any = null;
          let resultData400 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result400 = ProblemDetails.fromJS(resultData400);
          return throwException('Bad Request', status, _responseText, _headers, result400);
        })
      );
    } else if (status === 401) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result401: any = null;
          let resultData401 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result401 = ProblemDetails.fromJS(resultData401);
          return throwException('Unauthorized', status, _responseText, _headers, result401);
        })
      );
    } else if (status === 403) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result403: any = null;
          let resultData403 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result403 = ProblemDetails.fromJS(resultData403);
          return throwException('Forbidden', status, _responseText, _headers, result403);
        })
      );
    } else if (status === 404) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result404: any = null;
          let resultData404 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result404 = ProblemDetails.fromJS(resultData404);
          return throwException('Not Found', status, _responseText, _headers, result404);
        })
      );
    } else if (status === 409) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result409: any = null;
          let resultData409 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result409 = ProblemDetails.fromJS(resultData409);
          return throwException('Conflict', status, _responseText, _headers, result409);
        })
      );
    } else if (status === 500) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return throwException('Internal Server Error', status, _responseText, _headers);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        })
      );
    }
    return _observableOf(null as any);
  }

  /**
   * Generates an AI preview without recording a clinical run.
   *
   * @param body (optional)
   * @returns OK
   */
  generate2(body?: GeneratePreviewAiRequest | undefined): Observable<GenerateAssessmentAiResponse> {
    let url_ = this.baseUrl + '/api/Agent/preview/generate';
    url_ = url_.replace(/[?&]$/, '');

    const content_ = JSON.stringify(body);

    let options_: any = {
      body: content_,
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        Accept: 'application/json',
      }),
    };

    return this.http
      .request('post', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processGenerate2(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processGenerate2(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<GenerateAssessmentAiResponse>;
            }
          } else return _observableThrow(response_) as any as Observable<GenerateAssessmentAiResponse>;
        })
      );
  }

  protected processGenerate2(response: HttpResponseBase): Observable<GenerateAssessmentAiResponse> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
          ? (response as any).error
          : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result200: any = null;
          let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result200 = GenerateAssessmentAiResponse.fromJS(resultData200);
          return _observableOf(result200);
        })
      );
    } else if (status === 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return throwException('No Content', status, _responseText, _headers);
        })
      );
    } else if (status === 400) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result400: any = null;
          let resultData400 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result400 = ProblemDetails.fromJS(resultData400);
          return throwException('Bad Request', status, _responseText, _headers, result400);
        })
      );
    } else if (status === 401) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result401: any = null;
          let resultData401 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result401 = ProblemDetails.fromJS(resultData401);
          return throwException('Unauthorized', status, _responseText, _headers, result401);
        })
      );
    } else if (status === 403) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result403: any = null;
          let resultData403 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result403 = ProblemDetails.fromJS(resultData403);
          return throwException('Forbidden', status, _responseText, _headers, result403);
        })
      );
    } else if (status === 404) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result404: any = null;
          let resultData404 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result404 = ProblemDetails.fromJS(resultData404);
          return throwException('Not Found', status, _responseText, _headers, result404);
        })
      );
    } else if (status === 409) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result409: any = null;
          let resultData409 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result409 = ProblemDetails.fromJS(resultData409);
          return throwException('Conflict', status, _responseText, _headers, result409);
        })
      );
    } else if (status === 500) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return throwException('Internal Server Error', status, _responseText, _headers);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        })
      );
    }
    return _observableOf(null as any);
  }

  /**
   * Returns the AI configuration (feature toggle and prompt mapping) for a client.
   *
   * @returns OK
   */
  aiConfigGET(clientId: number): Observable<ClientAiConfigResponse> {
    let url_ = this.baseUrl + '/api/agent/clients/{clientId}/ai-config';
    if (clientId === undefined || clientId === null)
      throw new globalThis.Error("The parameter 'clientId' must be defined.");
    url_ = url_.replace('{clientId}', encodeURIComponent('' + clientId));
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        Accept: 'application/json',
      }),
    };

    return this.http
      .request('get', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processAiConfigGET(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processAiConfigGET(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<ClientAiConfigResponse>;
            }
          } else return _observableThrow(response_) as any as Observable<ClientAiConfigResponse>;
        })
      );
  }

  protected processAiConfigGET(response: HttpResponseBase): Observable<ClientAiConfigResponse> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
          ? (response as any).error
          : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result200: any = null;
          let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result200 = ClientAiConfigResponse.fromJS(resultData200);
          return _observableOf(result200);
        })
      );
    } else if (status === 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return throwException('No Content', status, _responseText, _headers);
        })
      );
    } else if (status === 400) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result400: any = null;
          let resultData400 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result400 = ProblemDetails.fromJS(resultData400);
          return throwException('Bad Request', status, _responseText, _headers, result400);
        })
      );
    } else if (status === 401) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result401: any = null;
          let resultData401 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result401 = ProblemDetails.fromJS(resultData401);
          return throwException('Unauthorized', status, _responseText, _headers, result401);
        })
      );
    } else if (status === 403) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result403: any = null;
          let resultData403 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result403 = ProblemDetails.fromJS(resultData403);
          return throwException('Forbidden', status, _responseText, _headers, result403);
        })
      );
    } else if (status === 404) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result404: any = null;
          let resultData404 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result404 = ProblemDetails.fromJS(resultData404);
          return throwException('Not Found', status, _responseText, _headers, result404);
        })
      );
    } else if (status === 409) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result409: any = null;
          let resultData409 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result409 = ProblemDetails.fromJS(resultData409);
          return throwException('Conflict', status, _responseText, _headers, result409);
        })
      );
    } else if (status === 500) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return throwException('Internal Server Error', status, _responseText, _headers);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        })
      );
    }
    return _observableOf(null as any);
  }

  /**
   * Saves the AI feature toggle and prompt library mapping for a client.
   *
   * @param body (optional)
   * @returns No Content
   */
  aiConfigPUT(clientId: number, body?: SaveClientAiConfigRequest | undefined): Observable<void> {
    let url_ = this.baseUrl + '/api/agent/clients/{clientId}/ai-config';
    if (clientId === undefined || clientId === null)
      throw new globalThis.Error("The parameter 'clientId' must be defined.");
    url_ = url_.replace('{clientId}', encodeURIComponent('' + clientId));
    url_ = url_.replace(/[?&]$/, '');

    const content_ = JSON.stringify(body);

    let options_: any = {
      body: content_,
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
      }),
    };

    return this.http
      .request('put', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processAiConfigPUT(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processAiConfigPUT(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<void>;
            }
          } else return _observableThrow(response_) as any as Observable<void>;
        })
      );
  }

  protected processAiConfigPUT(response: HttpResponseBase): Observable<void> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
          ? (response as any).error
          : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return _observableOf(null as any);
        })
      );
    } else if (status === 400) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result400: any = null;
          let resultData400 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result400 = ProblemDetails.fromJS(resultData400);
          return throwException('Bad Request', status, _responseText, _headers, result400);
        })
      );
    } else if (status === 401) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result401: any = null;
          let resultData401 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result401 = ProblemDetails.fromJS(resultData401);
          return throwException('Unauthorized', status, _responseText, _headers, result401);
        })
      );
    } else if (status === 403) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result403: any = null;
          let resultData403 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result403 = ProblemDetails.fromJS(resultData403);
          return throwException('Forbidden', status, _responseText, _headers, result403);
        })
      );
    } else if (status === 404) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result404: any = null;
          let resultData404 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result404 = ProblemDetails.fromJS(resultData404);
          return throwException('Not Found', status, _responseText, _headers, result404);
        })
      );
    } else if (status === 409) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result409: any = null;
          let resultData409 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result409 = ProblemDetails.fromJS(resultData409);
          return throwException('Conflict', status, _responseText, _headers, result409);
        })
      );
    } else if (status === 500) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return throwException('Internal Server Error', status, _responseText, _headers);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        })
      );
    }
    return _observableOf(null as any);
  }

  /** @returns OK */
  health(): Observable<void> {
    let url_ = this.baseUrl + '/health';
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({}),
    };

    return this.http
      .request('get', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processHealth(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processHealth(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<void>;
            }
          } else return _observableThrow(response_) as any as Observable<void>;
        })
      );
  }

  protected processHealth(response: HttpResponseBase): Observable<void> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
          ? (response as any).error
          : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return _observableOf(null as any);
        })
      );
    } else if (status === 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return _observableOf(null as any);
        })
      );
    } else if (status === 400) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result400: any = null;
          let resultData400 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result400 = ProblemDetails.fromJS(resultData400);
          return throwException('Bad Request', status, _responseText, _headers, result400);
        })
      );
    } else if (status === 401) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result401: any = null;
          let resultData401 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result401 = ProblemDetails.fromJS(resultData401);
          return throwException('Unauthorized', status, _responseText, _headers, result401);
        })
      );
    } else if (status === 403) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result403: any = null;
          let resultData403 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result403 = ProblemDetails.fromJS(resultData403);
          return throwException('Forbidden', status, _responseText, _headers, result403);
        })
      );
    } else if (status === 404) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result404: any = null;
          let resultData404 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result404 = ProblemDetails.fromJS(resultData404);
          return throwException('Not Found', status, _responseText, _headers, result404);
        })
      );
    } else if (status === 409) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result409: any = null;
          let resultData409 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result409 = ProblemDetails.fromJS(resultData409);
          return throwException('Conflict', status, _responseText, _headers, result409);
        })
      );
    } else if (status === 500) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return throwException('Internal Server Error', status, _responseText, _headers);
        })
      );
    } else if (status === 503) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return throwException('Service Unavailable', status, _responseText, _headers);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        })
      );
    }
    return _observableOf(null as any);
  }

  /** @returns OK */
  detailed(): Observable<HealthCheckResponse> {
    let url_ = this.baseUrl + '/health/detailed';
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        Accept: 'application/json',
      }),
    };

    return this.http
      .request('get', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processDetailed(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processDetailed(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<HealthCheckResponse>;
            }
          } else return _observableThrow(response_) as any as Observable<HealthCheckResponse>;
        })
      );
  }

  protected processDetailed(response: HttpResponseBase): Observable<HealthCheckResponse> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
          ? (response as any).error
          : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result200: any = null;
          let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result200 = HealthCheckResponse.fromJS(resultData200);
          return _observableOf(result200);
        })
      );
    } else if (status === 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return throwException('No Content', status, _responseText, _headers);
        })
      );
    } else if (status === 400) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result400: any = null;
          let resultData400 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result400 = ProblemDetails.fromJS(resultData400);
          return throwException('Bad Request', status, _responseText, _headers, result400);
        })
      );
    } else if (status === 401) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result401: any = null;
          let resultData401 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result401 = ProblemDetails.fromJS(resultData401);
          return throwException('Unauthorized', status, _responseText, _headers, result401);
        })
      );
    } else if (status === 403) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result403: any = null;
          let resultData403 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result403 = ProblemDetails.fromJS(resultData403);
          return throwException('Forbidden', status, _responseText, _headers, result403);
        })
      );
    } else if (status === 404) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result404: any = null;
          let resultData404 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result404 = ProblemDetails.fromJS(resultData404);
          return throwException('Not Found', status, _responseText, _headers, result404);
        })
      );
    } else if (status === 409) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result409: any = null;
          let resultData409 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result409 = ProblemDetails.fromJS(resultData409);
          return throwException('Conflict', status, _responseText, _headers, result409);
        })
      );
    } else if (status === 500) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return throwException('Internal Server Error', status, _responseText, _headers);
        })
      );
    } else if (status === 503) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result503: any = null;
          let resultData503 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result503 = HealthCheckResponse.fromJS(resultData503);
          return throwException('Service Unavailable', status, _responseText, _headers, result503);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        })
      );
    }
    return _observableOf(null as any);
  }

  /**
   * @param page (optional)
   * @param pageSize (optional)
   * @param search (optional)
   * @returns OK
   */
  promptLibrariesGET(
    page?: number | undefined,
    pageSize?: number | undefined,
    search?: string | undefined
  ): Observable<PromptLibraryResponsePagedResult> {
    let url_ = this.baseUrl + '/api/agent/PromptLibraries?';
    if (page === null) throw new globalThis.Error("The parameter 'page' cannot be null.");
    else if (page !== undefined) url_ += 'page=' + encodeURIComponent('' + page) + '&';
    if (pageSize === null) throw new globalThis.Error("The parameter 'pageSize' cannot be null.");
    else if (pageSize !== undefined) url_ += 'pageSize=' + encodeURIComponent('' + pageSize) + '&';
    if (search === null) throw new globalThis.Error("The parameter 'search' cannot be null.");
    else if (search !== undefined) url_ += 'search=' + encodeURIComponent('' + search) + '&';
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        Accept: 'application/json',
      }),
    };

    return this.http
      .request('get', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processPromptLibrariesGET(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processPromptLibrariesGET(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<PromptLibraryResponsePagedResult>;
            }
          } else return _observableThrow(response_) as any as Observable<PromptLibraryResponsePagedResult>;
        })
      );
  }

  protected processPromptLibrariesGET(response: HttpResponseBase): Observable<PromptLibraryResponsePagedResult> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
          ? (response as any).error
          : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result200: any = null;
          let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result200 = PromptLibraryResponsePagedResult.fromJS(resultData200);
          return _observableOf(result200);
        })
      );
    } else if (status === 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return throwException('No Content', status, _responseText, _headers);
        })
      );
    } else if (status === 400) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result400: any = null;
          let resultData400 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result400 = ProblemDetails.fromJS(resultData400);
          return throwException('Bad Request', status, _responseText, _headers, result400);
        })
      );
    } else if (status === 401) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result401: any = null;
          let resultData401 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result401 = ProblemDetails.fromJS(resultData401);
          return throwException('Unauthorized', status, _responseText, _headers, result401);
        })
      );
    } else if (status === 403) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result403: any = null;
          let resultData403 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result403 = ProblemDetails.fromJS(resultData403);
          return throwException('Forbidden', status, _responseText, _headers, result403);
        })
      );
    } else if (status === 404) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result404: any = null;
          let resultData404 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result404 = ProblemDetails.fromJS(resultData404);
          return throwException('Not Found', status, _responseText, _headers, result404);
        })
      );
    } else if (status === 409) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result409: any = null;
          let resultData409 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result409 = ProblemDetails.fromJS(resultData409);
          return throwException('Conflict', status, _responseText, _headers, result409);
        })
      );
    } else if (status === 500) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return throwException('Internal Server Error', status, _responseText, _headers);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        })
      );
    }
    return _observableOf(null as any);
  }

  /**
   * @param body (optional)
   * @returns No Content
   */
  promptLibrariesPOST(body?: SavePromptLibraryRequest | undefined): Observable<void> {
    let url_ = this.baseUrl + '/api/agent/PromptLibraries';
    url_ = url_.replace(/[?&]$/, '');

    const content_ = JSON.stringify(body);

    let options_: any = {
      body: content_,
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
      }),
    };

    return this.http
      .request('post', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processPromptLibrariesPOST(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processPromptLibrariesPOST(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<void>;
            }
          } else return _observableThrow(response_) as any as Observable<void>;
        })
      );
  }

  protected processPromptLibrariesPOST(response: HttpResponseBase): Observable<void> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
          ? (response as any).error
          : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 201) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          // 201 Created is a success status - return success, not exception
          return _observableOf(null as any);
        })
      );
    } else if (status === 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return _observableOf(null as any);
        })
      );
    } else if (status === 400) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result400: any = null;
          let resultData400 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result400 = ProblemDetails.fromJS(resultData400);
          return throwException('Bad Request', status, _responseText, _headers, result400);
        })
      );
    } else if (status === 401) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result401: any = null;
          let resultData401 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result401 = ProblemDetails.fromJS(resultData401);
          return throwException('Unauthorized', status, _responseText, _headers, result401);
        })
      );
    } else if (status === 403) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result403: any = null;
          let resultData403 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result403 = ProblemDetails.fromJS(resultData403);
          return throwException('Forbidden', status, _responseText, _headers, result403);
        })
      );
    } else if (status === 404) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result404: any = null;
          let resultData404 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result404 = ProblemDetails.fromJS(resultData404);
          return throwException('Not Found', status, _responseText, _headers, result404);
        })
      );
    } else if (status === 409) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result409: any = null;
          let resultData409 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result409 = ProblemDetails.fromJS(resultData409);
          return throwException('Conflict', status, _responseText, _headers, result409);
        })
      );
    } else if (status === 500) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return throwException('Internal Server Error', status, _responseText, _headers);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        })
      );
    }
    return _observableOf(null as any);
  }

  /** @returns No Content */
  promptLibrariesGET2(id: number): Observable<void> {
    let url_ = this.baseUrl + '/api/agent/PromptLibraries/{id}';
    if (id === undefined || id === null) throw new globalThis.Error("The parameter 'id' must be defined.");
    url_ = url_.replace('{id}', encodeURIComponent('' + id));
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({}),
    };

    return this.http
      .request('get', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processPromptLibrariesGET2(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processPromptLibrariesGET2(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<void>;
            }
          } else return _observableThrow(response_) as any as Observable<void>;
        })
      );
  }

  protected processPromptLibrariesGET2(response: HttpResponseBase): Observable<void> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
          ? (response as any).error
          : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return _observableOf(null as any);
        })
      );
    } else if (status === 400) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result400: any = null;
          let resultData400 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result400 = ProblemDetails.fromJS(resultData400);
          return throwException('Bad Request', status, _responseText, _headers, result400);
        })
      );
    } else if (status === 401) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result401: any = null;
          let resultData401 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result401 = ProblemDetails.fromJS(resultData401);
          return throwException('Unauthorized', status, _responseText, _headers, result401);
        })
      );
    } else if (status === 403) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result403: any = null;
          let resultData403 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result403 = ProblemDetails.fromJS(resultData403);
          return throwException('Forbidden', status, _responseText, _headers, result403);
        })
      );
    } else if (status === 404) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result404: any = null;
          let resultData404 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result404 = ProblemDetails.fromJS(resultData404);
          return throwException('Not Found', status, _responseText, _headers, result404);
        })
      );
    } else if (status === 409) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result409: any = null;
          let resultData409 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result409 = ProblemDetails.fromJS(resultData409);
          return throwException('Conflict', status, _responseText, _headers, result409);
        })
      );
    } else if (status === 500) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return throwException('Internal Server Error', status, _responseText, _headers);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        })
      );
    }
    return _observableOf(null as any);
  }

  /**
   * @param body (optional)
   * @returns No Content
   */
  promptLibrariesPUT(id: number, body?: SavePromptLibraryRequest | undefined): Observable<void> {
    let url_ = this.baseUrl + '/api/agent/PromptLibraries/{id}';
    if (id === undefined || id === null) throw new globalThis.Error("The parameter 'id' must be defined.");
    url_ = url_.replace('{id}', encodeURIComponent('' + id));
    url_ = url_.replace(/[?&]$/, '');

    const content_ = JSON.stringify(body);

    let options_: any = {
      body: content_,
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
      }),
    };

    return this.http
      .request('put', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processPromptLibrariesPUT(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processPromptLibrariesPUT(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<void>;
            }
          } else return _observableThrow(response_) as any as Observable<void>;
        })
      );
  }

  protected processPromptLibrariesPUT(response: HttpResponseBase): Observable<void> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
          ? (response as any).error
          : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return _observableOf(null as any);
        })
      );
    } else if (status === 400) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result400: any = null;
          let resultData400 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result400 = ProblemDetails.fromJS(resultData400);
          return throwException('Bad Request', status, _responseText, _headers, result400);
        })
      );
    } else if (status === 401) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result401: any = null;
          let resultData401 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result401 = ProblemDetails.fromJS(resultData401);
          return throwException('Unauthorized', status, _responseText, _headers, result401);
        })
      );
    } else if (status === 403) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result403: any = null;
          let resultData403 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result403 = ProblemDetails.fromJS(resultData403);
          return throwException('Forbidden', status, _responseText, _headers, result403);
        })
      );
    } else if (status === 404) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result404: any = null;
          let resultData404 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result404 = ProblemDetails.fromJS(resultData404);
          return throwException('Not Found', status, _responseText, _headers, result404);
        })
      );
    } else if (status === 409) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result409: any = null;
          let resultData409 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result409 = ProblemDetails.fromJS(resultData409);
          return throwException('Conflict', status, _responseText, _headers, result409);
        })
      );
    } else if (status === 500) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return throwException('Internal Server Error', status, _responseText, _headers);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        })
      );
    }
    return _observableOf(null as any);
  }

  /**
   * @param body (optional)
   * @returns No Content
   */
  status(id: number, body?: UpdateStatusRequest | undefined): Observable<void> {
    let url_ = this.baseUrl + '/api/agent/PromptLibraries/{id}/status';
    if (id === undefined || id === null) throw new globalThis.Error("The parameter 'id' must be defined.");
    url_ = url_.replace('{id}', encodeURIComponent('' + id));
    url_ = url_.replace(/[?&]$/, '');

    const content_ = JSON.stringify(body);

    let options_: any = {
      body: content_,
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
      }),
    };

    return this.http
      .request('patch', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processStatus(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processStatus(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<void>;
            }
          } else return _observableThrow(response_) as any as Observable<void>;
        })
      );
  }

  protected processStatus(response: HttpResponseBase): Observable<void> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
          ? (response as any).error
          : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return _observableOf(null as any);
        })
      );
    } else if (status === 400) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result400: any = null;
          let resultData400 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result400 = ProblemDetails.fromJS(resultData400);
          return throwException('Bad Request', status, _responseText, _headers, result400);
        })
      );
    } else if (status === 401) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result401: any = null;
          let resultData401 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result401 = ProblemDetails.fromJS(resultData401);
          return throwException('Unauthorized', status, _responseText, _headers, result401);
        })
      );
    } else if (status === 403) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result403: any = null;
          let resultData403 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result403 = ProblemDetails.fromJS(resultData403);
          return throwException('Forbidden', status, _responseText, _headers, result403);
        })
      );
    } else if (status === 404) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result404: any = null;
          let resultData404 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result404 = ProblemDetails.fromJS(resultData404);
          return throwException('Not Found', status, _responseText, _headers, result404);
        })
      );
    } else if (status === 409) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result409: any = null;
          let resultData409 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result409 = ProblemDetails.fromJS(resultData409);
          return throwException('Conflict', status, _responseText, _headers, result409);
        })
      );
    } else if (status === 500) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return throwException('Internal Server Error', status, _responseText, _headers);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        })
      );
    }
    return _observableOf(null as any);
  }

  /** @returns No Content */
  promptsGET(id: number): Observable<void> {
    let url_ = this.baseUrl + '/api/agent/PromptLibraries/{id}/prompts';
    if (id === undefined || id === null) throw new globalThis.Error("The parameter 'id' must be defined.");
    url_ = url_.replace('{id}', encodeURIComponent('' + id));
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({}),
    };

    return this.http
      .request('get', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processPromptsGET(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processPromptsGET(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<void>;
            }
          } else return _observableThrow(response_) as any as Observable<void>;
        })
      );
  }

  protected processPromptsGET(response: HttpResponseBase): Observable<void> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
          ? (response as any).error
          : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return _observableOf(null as any);
        })
      );
    } else if (status === 400) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result400: any = null;
          let resultData400 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result400 = ProblemDetails.fromJS(resultData400);
          return throwException('Bad Request', status, _responseText, _headers, result400);
        })
      );
    } else if (status === 401) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result401: any = null;
          let resultData401 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result401 = ProblemDetails.fromJS(resultData401);
          return throwException('Unauthorized', status, _responseText, _headers, result401);
        })
      );
    } else if (status === 403) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result403: any = null;
          let resultData403 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result403 = ProblemDetails.fromJS(resultData403);
          return throwException('Forbidden', status, _responseText, _headers, result403);
        })
      );
    } else if (status === 404) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result404: any = null;
          let resultData404 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result404 = ProblemDetails.fromJS(resultData404);
          return throwException('Not Found', status, _responseText, _headers, result404);
        })
      );
    } else if (status === 409) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result409: any = null;
          let resultData409 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result409 = ProblemDetails.fromJS(resultData409);
          return throwException('Conflict', status, _responseText, _headers, result409);
        })
      );
    } else if (status === 500) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return throwException('Internal Server Error', status, _responseText, _headers);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        })
      );
    }
    return _observableOf(null as any);
  }

  /**
   * @param body (optional)
   * @returns No Content
   */
  promptsPOST(id: number, body?: SavePromptRequest | undefined): Observable<void> {
    let url_ = this.baseUrl + '/api/agent/PromptLibraries/{id}/prompts';
    if (id === undefined || id === null) throw new globalThis.Error("The parameter 'id' must be defined.");
    url_ = url_.replace('{id}', encodeURIComponent('' + id));
    url_ = url_.replace(/[?&]$/, '');

    const content_ = JSON.stringify(body);

    let options_: any = {
      body: content_,
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
      }),
    };

    return this.http
      .request('post', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processPromptsPOST(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processPromptsPOST(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<void>;
            }
          } else return _observableThrow(response_) as any as Observable<void>;
        })
      );
  }

  protected processPromptsPOST(response: HttpResponseBase): Observable<void> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
          ? (response as any).error
          : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 201) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          // 201 Created is a success status - return success, not exception
          return _observableOf(null as any);
        })
      );
    } else if (status === 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return _observableOf(null as any);
        })
      );
    } else if (status === 400) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result400: any = null;
          let resultData400 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result400 = ProblemDetails.fromJS(resultData400);
          return throwException('Bad Request', status, _responseText, _headers, result400);
        })
      );
    } else if (status === 401) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result401: any = null;
          let resultData401 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result401 = ProblemDetails.fromJS(resultData401);
          return throwException('Unauthorized', status, _responseText, _headers, result401);
        })
      );
    } else if (status === 403) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result403: any = null;
          let resultData403 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result403 = ProblemDetails.fromJS(resultData403);
          return throwException('Forbidden', status, _responseText, _headers, result403);
        })
      );
    } else if (status === 404) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result404: any = null;
          let resultData404 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result404 = ProblemDetails.fromJS(resultData404);
          return throwException('Not Found', status, _responseText, _headers, result404);
        })
      );
    } else if (status === 409) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result409: any = null;
          let resultData409 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result409 = ProblemDetails.fromJS(resultData409);
          return throwException('Conflict', status, _responseText, _headers, result409);
        })
      );
    } else if (status === 500) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return throwException('Internal Server Error', status, _responseText, _headers);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        })
      );
    }
    return _observableOf(null as any);
  }

  /**
   * @param body (optional)
   * @returns No Content
   */
  promptsPUT(promptId: number, body?: SavePromptRequest | undefined): Observable<void> {
    let url_ = this.baseUrl + '/api/agent/PromptLibraries/prompts/{promptId}';
    if (promptId === undefined || promptId === null)
      throw new globalThis.Error("The parameter 'promptId' must be defined.");
    url_ = url_.replace('{promptId}', encodeURIComponent('' + promptId));
    url_ = url_.replace(/[?&]$/, '');

    const content_ = JSON.stringify(body);

    let options_: any = {
      body: content_,
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
      }),
    };

    return this.http
      .request('put', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processPromptsPUT(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processPromptsPUT(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<void>;
            }
          } else return _observableThrow(response_) as any as Observable<void>;
        })
      );
  }

  protected processPromptsPUT(response: HttpResponseBase): Observable<void> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
          ? (response as any).error
          : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return _observableOf(null as any);
        })
      );
    } else if (status === 400) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result400: any = null;
          let resultData400 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result400 = ProblemDetails.fromJS(resultData400);
          return throwException('Bad Request', status, _responseText, _headers, result400);
        })
      );
    } else if (status === 401) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result401: any = null;
          let resultData401 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result401 = ProblemDetails.fromJS(resultData401);
          return throwException('Unauthorized', status, _responseText, _headers, result401);
        })
      );
    } else if (status === 403) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result403: any = null;
          let resultData403 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result403 = ProblemDetails.fromJS(resultData403);
          return throwException('Forbidden', status, _responseText, _headers, result403);
        })
      );
    } else if (status === 404) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result404: any = null;
          let resultData404 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result404 = ProblemDetails.fromJS(resultData404);
          return throwException('Not Found', status, _responseText, _headers, result404);
        })
      );
    } else if (status === 409) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result409: any = null;
          let resultData409 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result409 = ProblemDetails.fromJS(resultData409);
          return throwException('Conflict', status, _responseText, _headers, result409);
        })
      );
    } else if (status === 500) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return throwException('Internal Server Error', status, _responseText, _headers);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        })
      );
    }
    return _observableOf(null as any);
  }

  /**
   * @param body (optional)
   * @returns No Content
   */
  status2(promptId: number, body?: UpdateStatusRequest | undefined): Observable<void> {
    let url_ = this.baseUrl + '/api/agent/PromptLibraries/prompts/{promptId}/status';
    if (promptId === undefined || promptId === null)
      throw new globalThis.Error("The parameter 'promptId' must be defined.");
    url_ = url_.replace('{promptId}', encodeURIComponent('' + promptId));
    url_ = url_.replace(/[?&]$/, '');

    const content_ = JSON.stringify(body);

    let options_: any = {
      body: content_,
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
      }),
    };

    return this.http
      .request('patch', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processStatus2(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processStatus2(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<void>;
            }
          } else return _observableThrow(response_) as any as Observable<void>;
        })
      );
  }

  protected processStatus2(response: HttpResponseBase): Observable<void> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
          ? (response as any).error
          : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return _observableOf(null as any);
        })
      );
    } else if (status === 400) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result400: any = null;
          let resultData400 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result400 = ProblemDetails.fromJS(resultData400);
          return throwException('Bad Request', status, _responseText, _headers, result400);
        })
      );
    } else if (status === 401) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result401: any = null;
          let resultData401 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result401 = ProblemDetails.fromJS(resultData401);
          return throwException('Unauthorized', status, _responseText, _headers, result401);
        })
      );
    } else if (status === 403) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result403: any = null;
          let resultData403 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result403 = ProblemDetails.fromJS(resultData403);
          return throwException('Forbidden', status, _responseText, _headers, result403);
        })
      );
    } else if (status === 404) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result404: any = null;
          let resultData404 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result404 = ProblemDetails.fromJS(resultData404);
          return throwException('Not Found', status, _responseText, _headers, result404);
        })
      );
    } else if (status === 409) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result409: any = null;
          let resultData409 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result409 = ProblemDetails.fromJS(resultData409);
          return throwException('Conflict', status, _responseText, _headers, result409);
        })
      );
    } else if (status === 500) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return throwException('Internal Server Error', status, _responseText, _headers);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        })
      );
    }
    return _observableOf(null as any);
  }
}

export class AiOutputResponse implements IAiOutputResponse {
  subjectiveSummary?: string | undefined;
  objectiveSummary?: string | undefined;
  assessmentSummary?: string | undefined;
  planSummary?: string | undefined;
  codingSuggestions?: string[] | undefined;
  riskFlags?: string[] | undefined;

  constructor(data?: IAiOutputResponse) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (this as any)[property] = (data as any)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.subjectiveSummary = _data['subjectiveSummary'];
      this.objectiveSummary = _data['objectiveSummary'];
      this.assessmentSummary = _data['assessmentSummary'];
      this.planSummary = _data['planSummary'];
      if (Array.isArray(_data['codingSuggestions'])) {
        this.codingSuggestions = [] as any;
        for (let item of _data['codingSuggestions']) this.codingSuggestions!.push(item);
      }
      if (Array.isArray(_data['riskFlags'])) {
        this.riskFlags = [] as any;
        for (let item of _data['riskFlags']) this.riskFlags!.push(item);
      }
    }
  }

  static fromJS(data: any): AiOutputResponse {
    data = typeof data === 'object' ? data : {};
    let result = new AiOutputResponse();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data['subjectiveSummary'] = this.subjectiveSummary;
    data['objectiveSummary'] = this.objectiveSummary;
    data['assessmentSummary'] = this.assessmentSummary;
    data['planSummary'] = this.planSummary;
    if (Array.isArray(this.codingSuggestions)) {
      data['codingSuggestions'] = [];
      for (let item of this.codingSuggestions) data['codingSuggestions'].push(item);
    }
    if (Array.isArray(this.riskFlags)) {
      data['riskFlags'] = [];
      for (let item of this.riskFlags) data['riskFlags'].push(item);
    }
    return data;
  }
}

export interface IAiOutputResponse {
  subjectiveSummary?: string | undefined;
  objectiveSummary?: string | undefined;
  assessmentSummary?: string | undefined;
  planSummary?: string | undefined;
  codingSuggestions?: string[] | undefined;
  riskFlags?: string[] | undefined;
}

export class AssessmentAiRunSummaryResponse implements IAssessmentAiRunSummaryResponse {
  runId?: number;
  status?: string | undefined;
  runType?: string | undefined;
  modelName?: string | undefined;
  totalTokens?: number | undefined;
  startedAt?: string;
  completedAt?: string | undefined;

  constructor(data?: IAssessmentAiRunSummaryResponse) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (this as any)[property] = (data as any)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.runId = _data['runId'];
      this.status = _data['status'];
      this.runType = _data['runType'];
      this.modelName = _data['modelName'];
      this.totalTokens = _data['totalTokens'];
      this.startedAt = _data['startedAt'];
      this.completedAt = _data['completedAt'];
    }
  }

  static fromJS(data: any): AssessmentAiRunSummaryResponse {
    data = typeof data === 'object' ? data : {};
    let result = new AssessmentAiRunSummaryResponse();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data['runId'] = this.runId;
    data['status'] = this.status;
    data['runType'] = this.runType;
    data['modelName'] = this.modelName;
    data['totalTokens'] = this.totalTokens;
    data['startedAt'] = this.startedAt;
    data['completedAt'] = this.completedAt;
    return data;
  }
}

export interface IAssessmentAiRunSummaryResponse {
  runId?: number;
  status?: string | undefined;
  runType?: string | undefined;
  modelName?: string | undefined;
  totalTokens?: number | undefined;
  startedAt?: string;
  completedAt?: string | undefined;
}

export class AssessmentAiRunSummaryResponsePagedResult implements IAssessmentAiRunSummaryResponsePagedResult {
  items?: AssessmentAiRunSummaryResponse[] | undefined;
  readonly pageIndex?: number;
  readonly pageSize?: number;
  totalItems?: number;
  readonly totalPages?: number;
  readonly hasPreviousPage?: boolean;
  readonly hasNextPage?: boolean;

  constructor(data?: IAssessmentAiRunSummaryResponsePagedResult) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (this as any)[property] = (data as any)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      if (Array.isArray(_data['items'])) {
        this.items = [] as any;
        for (let item of _data['items']) this.items!.push(AssessmentAiRunSummaryResponse.fromJS(item));
      }
      (this as any).pageIndex = _data['pageIndex'];
      (this as any).pageSize = _data['pageSize'];
      this.totalItems = _data['totalItems'];
      (this as any).totalPages = _data['totalPages'];
      (this as any).hasPreviousPage = _data['hasPreviousPage'];
      (this as any).hasNextPage = _data['hasNextPage'];
    }
  }

  static fromJS(data: any): AssessmentAiRunSummaryResponsePagedResult {
    data = typeof data === 'object' ? data : {};
    let result = new AssessmentAiRunSummaryResponsePagedResult();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    if (Array.isArray(this.items)) {
      data['items'] = [];
      for (let item of this.items) data['items'].push(item ? item.toJSON() : (undefined as any));
    }
    data['pageIndex'] = this.pageIndex;
    data['pageSize'] = this.pageSize;
    data['totalItems'] = this.totalItems;
    data['totalPages'] = this.totalPages;
    data['hasPreviousPage'] = this.hasPreviousPage;
    data['hasNextPage'] = this.hasNextPage;
    return data;
  }
}

export interface IAssessmentAiRunSummaryResponsePagedResult {
  items?: AssessmentAiRunSummaryResponse[] | undefined;
  pageIndex?: number;
  pageSize?: number;
  totalItems?: number;
  totalPages?: number;
  hasPreviousPage?: boolean;
  hasNextPage?: boolean;
}

export class ClientAiConfigResponse implements IClientAiConfigResponse {
  clientId?: number;
  isEnabled?: boolean;
  features?: ClientFeatureSettingResponse[] | undefined;
  promptLibraryIds?: number[] | undefined;
  promptLibraryNames?: string[] | undefined;
  overridePrompts?: ClientPromptOverrideResponse[] | undefined;
  featurePromptConfigurations?: ClientFeaturePromptConfigurationResponse[] | undefined;

  constructor(data?: IClientAiConfigResponse) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (this as any)[property] = (data as any)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.clientId = _data['clientId'];
      this.isEnabled = _data['isEnabled'];
      if (Array.isArray(_data['features'])) {
        this.features = [] as any;
        for (let item of _data['features']) this.features!.push(ClientFeatureSettingResponse.fromJS(item));
      }
      if (Array.isArray(_data['promptLibraryIds'])) {
        this.promptLibraryIds = [] as any;
        for (let item of _data['promptLibraryIds']) this.promptLibraryIds!.push(item);
      }
      if (Array.isArray(_data['promptLibraryNames'])) {
        this.promptLibraryNames = [] as any;
        for (let item of _data['promptLibraryNames']) this.promptLibraryNames!.push(item);
      }
      if (Array.isArray(_data['overridePrompts'])) {
        this.overridePrompts = [] as any;
        for (let item of _data['overridePrompts'])
          this.overridePrompts!.push(ClientPromptOverrideResponse.fromJS(item));
      }
      if (Array.isArray(_data['featurePromptConfigurations'])) {
        this.featurePromptConfigurations = [] as any;
        for (let item of _data['featurePromptConfigurations'])
          this.featurePromptConfigurations!.push(ClientFeaturePromptConfigurationResponse.fromJS(item));
      }
    }
  }

  static fromJS(data: any): ClientAiConfigResponse {
    data = typeof data === 'object' ? data : {};
    let result = new ClientAiConfigResponse();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data['clientId'] = this.clientId;
    data['isEnabled'] = this.isEnabled;
    if (Array.isArray(this.features)) {
      data['features'] = [];
      for (let item of this.features) data['features'].push(item ? item.toJSON() : (undefined as any));
    }
    if (Array.isArray(this.promptLibraryIds)) {
      data['promptLibraryIds'] = [];
      for (let item of this.promptLibraryIds) data['promptLibraryIds'].push(item);
    }
    if (Array.isArray(this.promptLibraryNames)) {
      data['promptLibraryNames'] = [];
      for (let item of this.promptLibraryNames) data['promptLibraryNames'].push(item);
    }
    if (Array.isArray(this.overridePrompts)) {
      data['overridePrompts'] = [];
      for (let item of this.overridePrompts) data['overridePrompts'].push(item ? item.toJSON() : (undefined as any));
    }
    if (Array.isArray(this.featurePromptConfigurations)) {
      data['featurePromptConfigurations'] = [];
      for (let item of this.featurePromptConfigurations)
        data['featurePromptConfigurations'].push(item ? item.toJSON() : (undefined as any));
    }
    return data;
  }
}

export interface IClientAiConfigResponse {
  clientId?: number;
  isEnabled?: boolean;
  features?: ClientFeatureSettingResponse[] | undefined;
  promptLibraryIds?: number[] | undefined;
  promptLibraryNames?: string[] | undefined;
  overridePrompts?: ClientPromptOverrideResponse[] | undefined;
  featurePromptConfigurations?: ClientFeaturePromptConfigurationResponse[] | undefined;
}

export class ClientFeaturePromptConfigurationResponse implements IClientFeaturePromptConfigurationResponse {
  featureKey!: string;
  promptLibraryIds?: number[] | undefined;
  promptIds?: number[] | undefined;
  constructor(data?: IClientFeaturePromptConfigurationResponse) {
    if (data) Object.assign(this, data);
  }
  init(_data?: any) {
    if (_data) {
      this.featureKey = _data['featureKey'];
      this.promptLibraryIds = _data['promptLibraryIds'];
      this.promptIds = _data['promptIds'];
    }
  }
  static fromJS(data: any): ClientFeaturePromptConfigurationResponse {
    const result = new ClientFeaturePromptConfigurationResponse();
    result.init(data);
    return result;
  }
  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data['featureKey'] = this.featureKey;
    data['promptLibraryIds'] = this.promptLibraryIds;
    data['promptIds'] = this.promptIds;
    return data;
  }
}

export interface IClientFeaturePromptConfigurationResponse {
  featureKey: string;
  promptLibraryIds?: number[] | undefined;
  promptIds?: number[] | undefined;
}

export class ClientFeatureSettingRequest implements IClientFeatureSettingRequest {
  featureKey!: string;
  isEnabled?: boolean;

  constructor(data?: IClientFeatureSettingRequest) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (this as any)[property] = (data as any)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.featureKey = _data['featureKey'];
      this.isEnabled = _data['isEnabled'];
    }
  }

  static fromJS(data: any): ClientFeatureSettingRequest {
    data = typeof data === 'object' ? data : {};
    let result = new ClientFeatureSettingRequest();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data['featureKey'] = this.featureKey;
    data['isEnabled'] = this.isEnabled;
    return data;
  }
}

export interface IClientFeatureSettingRequest {
  featureKey: string;
  isEnabled?: boolean;
}

export class ClientFeatureSettingResponse implements IClientFeatureSettingResponse {
  featureKey?: string | undefined;
  isEnabled?: boolean;

  constructor(data?: IClientFeatureSettingResponse) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (this as any)[property] = (data as any)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.featureKey = _data['featureKey'];
      this.isEnabled = _data['isEnabled'];
    }
  }

  static fromJS(data: any): ClientFeatureSettingResponse {
    data = typeof data === 'object' ? data : {};
    let result = new ClientFeatureSettingResponse();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data['featureKey'] = this.featureKey;
    data['isEnabled'] = this.isEnabled;
    return data;
  }
}

export interface IClientFeatureSettingResponse {
  featureKey?: string | undefined;
  isEnabled?: boolean;
}

export class ClientPromptOverrideRequest implements IClientPromptOverrideRequest {
  promptId?: number | undefined;
  overridePromptText?: string | undefined;

  constructor(data?: IClientPromptOverrideRequest) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (this as any)[property] = (data as any)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.promptId = _data['promptId'];
      this.overridePromptText = _data['overridePromptText'];
    }
  }

  static fromJS(data: any): ClientPromptOverrideRequest {
    data = typeof data === 'object' ? data : {};
    let result = new ClientPromptOverrideRequest();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data['promptId'] = this.promptId;
    data['overridePromptText'] = this.overridePromptText;
    return data;
  }
}

export interface IClientPromptOverrideRequest {
  promptId?: number | undefined;
  overridePromptText?: string | undefined;
}

export class ClientPromptOverrideResponse implements IClientPromptOverrideResponse {
  clientPromptMappingId?: number;
  promptId?: number | undefined;
  overridePromptText?: string | undefined;
  isActive?: boolean;

  constructor(data?: IClientPromptOverrideResponse) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (this as any)[property] = (data as any)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.clientPromptMappingId = _data['clientPromptMappingId'];
      this.promptId = _data['promptId'];
      this.overridePromptText = _data['overridePromptText'];
      this.isActive = _data['isActive'];
    }
  }

  static fromJS(data: any): ClientPromptOverrideResponse {
    data = typeof data === 'object' ? data : {};
    let result = new ClientPromptOverrideResponse();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data['clientPromptMappingId'] = this.clientPromptMappingId;
    data['promptId'] = this.promptId;
    data['overridePromptText'] = this.overridePromptText;
    data['isActive'] = this.isActive;
    return data;
  }
}

export interface IClientPromptOverrideResponse {
  clientPromptMappingId?: number;
  promptId?: number | undefined;
  overridePromptText?: string | undefined;
  isActive?: boolean;
}

export class GenerateAssessmentAiRequest implements IGenerateAssessmentAiRequest {
  clientId!: number;
  templateId!: string;
  templateVersionId?: string | undefined;
  assessmentStrategyTypeCode!: string;
  memberSummary!: MemberSummaryRequest;
  soapPayload!: SoapPayloadRequest;
  redactionSummary?: RedactionSummaryRequest;
  runtimeOptions?: RuntimeOptionsRequest;
  optionalUserInstruction?: string | undefined;
  correlationId?: string | undefined;

  constructor(data?: IGenerateAssessmentAiRequest) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (this as any)[property] = (data as any)[property];
      }
    }
    if (!data) {
      this.memberSummary = new MemberSummaryRequest();
      this.soapPayload = new SoapPayloadRequest();
    }
  }

  init(_data?: any) {
    if (_data) {
      this.clientId = _data['clientId'];
      this.templateId = _data['templateId'];
      this.templateVersionId = _data['templateVersionId'];
      this.assessmentStrategyTypeCode = _data['assessmentStrategyTypeCode'];
      this.memberSummary = _data['memberSummary']
        ? MemberSummaryRequest.fromJS(_data['memberSummary'])
        : new MemberSummaryRequest();
      this.soapPayload = _data['soapPayload']
        ? SoapPayloadRequest.fromJS(_data['soapPayload'])
        : new SoapPayloadRequest();
      this.redactionSummary = _data['redactionSummary']
        ? RedactionSummaryRequest.fromJS(_data['redactionSummary'])
        : (undefined as any);
      this.runtimeOptions = _data['runtimeOptions']
        ? RuntimeOptionsRequest.fromJS(_data['runtimeOptions'])
        : (undefined as any);
      this.optionalUserInstruction = _data['optionalUserInstruction'];
      this.correlationId = _data['correlationId'];
    }
  }

  static fromJS(data: any): GenerateAssessmentAiRequest {
    data = typeof data === 'object' ? data : {};
    let result = new GenerateAssessmentAiRequest();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data['clientId'] = this.clientId;
    data['templateId'] = this.templateId;
    data['templateVersionId'] = this.templateVersionId;
    data['assessmentStrategyTypeCode'] = this.assessmentStrategyTypeCode;
    data['memberSummary'] = this.memberSummary ? this.memberSummary.toJSON() : (undefined as any);
    data['soapPayload'] = this.soapPayload ? this.soapPayload.toJSON() : (undefined as any);
    data['redactionSummary'] = this.redactionSummary ? this.redactionSummary.toJSON() : (undefined as any);
    data['runtimeOptions'] = this.runtimeOptions ? this.runtimeOptions.toJSON() : (undefined as any);
    data['optionalUserInstruction'] = this.optionalUserInstruction;
    data['correlationId'] = this.correlationId;
    return data;
  }
}

export interface IGenerateAssessmentAiRequest {
  clientId: number;
  templateId: string;
  templateVersionId?: string | undefined;
  assessmentStrategyTypeCode: string;
  memberSummary: MemberSummaryRequest;
  soapPayload: SoapPayloadRequest;
  redactionSummary?: RedactionSummaryRequest;
  runtimeOptions?: RuntimeOptionsRequest;
  optionalUserInstruction?: string | undefined;
  correlationId?: string | undefined;
}

export class GenerateAssessmentAiResponse implements IGenerateAssessmentAiResponse {
  runId?: number;
  status?: string | undefined;
  output?: AiOutputResponse;
  tokenUsage?: TokenUsageResponse;
  modelMetadata?: ModelMetadataResponse;
  promptMetadata?: PromptMetadataResponse;

  constructor(data?: IGenerateAssessmentAiResponse) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (this as any)[property] = (data as any)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.runId = _data['runId'];
      this.status = _data['status'];
      this.output = _data['output'] ? AiOutputResponse.fromJS(_data['output']) : (undefined as any);
      this.tokenUsage = _data['tokenUsage'] ? TokenUsageResponse.fromJS(_data['tokenUsage']) : (undefined as any);
      this.modelMetadata = _data['modelMetadata']
        ? ModelMetadataResponse.fromJS(_data['modelMetadata'])
        : (undefined as any);
      this.promptMetadata = _data['promptMetadata']
        ? PromptMetadataResponse.fromJS(_data['promptMetadata'])
        : (undefined as any);
    }
  }

  static fromJS(data: any): GenerateAssessmentAiResponse {
    data = typeof data === 'object' ? data : {};
    let result = new GenerateAssessmentAiResponse();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data['runId'] = this.runId;
    data['status'] = this.status;
    data['output'] = this.output ? this.output.toJSON() : (undefined as any);
    data['tokenUsage'] = this.tokenUsage ? this.tokenUsage.toJSON() : (undefined as any);
    data['modelMetadata'] = this.modelMetadata ? this.modelMetadata.toJSON() : (undefined as any);
    data['promptMetadata'] = this.promptMetadata ? this.promptMetadata.toJSON() : (undefined as any);
    return data;
  }
}

export interface IGenerateAssessmentAiResponse {
  runId?: number;
  status?: string | undefined;
  output?: AiOutputResponse;
  tokenUsage?: TokenUsageResponse;
  modelMetadata?: ModelMetadataResponse;
  promptMetadata?: PromptMetadataResponse;
}

export class GeneratePreviewAiRequest implements IGeneratePreviewAiRequest {
  clientId!: number;
  templateId!: string;
  templateVersionId?: string | undefined;
  assessmentStrategyTypeCode!: string;
  memberSummary!: MemberSummaryRequest;
  soapPayload!: SoapPayloadRequest;
  redactionSummary?: RedactionSummaryRequest;
  runtimeOptions?: RuntimeOptionsRequest;
  optionalUserInstruction?: string | undefined;
  correlationId?: string | undefined;
  templateContextId?: string | undefined;
  promptLibraryIds?: number[] | undefined;
  promptIds?: number[] | undefined;
  promptOverrides?: PreviewPromptOverride[] | undefined;

  constructor(data?: IGeneratePreviewAiRequest) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (this as any)[property] = (data as any)[property];
      }
    }
    if (!data) {
      this.memberSummary = new MemberSummaryRequest();
      this.soapPayload = new SoapPayloadRequest();
    }
  }

  init(_data?: any) {
    if (_data) {
      this.clientId = _data['clientId'];
      this.templateId = _data['templateId'];
      this.templateVersionId = _data['templateVersionId'];
      this.assessmentStrategyTypeCode = _data['assessmentStrategyTypeCode'];
      this.memberSummary = _data['memberSummary']
        ? MemberSummaryRequest.fromJS(_data['memberSummary'])
        : new MemberSummaryRequest();
      this.soapPayload = _data['soapPayload']
        ? SoapPayloadRequest.fromJS(_data['soapPayload'])
        : new SoapPayloadRequest();
      this.redactionSummary = _data['redactionSummary']
        ? RedactionSummaryRequest.fromJS(_data['redactionSummary'])
        : (undefined as any);
      this.runtimeOptions = _data['runtimeOptions']
        ? RuntimeOptionsRequest.fromJS(_data['runtimeOptions'])
        : (undefined as any);
      this.optionalUserInstruction = _data['optionalUserInstruction'];
      this.correlationId = _data['correlationId'];
      this.templateContextId = _data['templateContextId'];
      if (Array.isArray(_data['promptLibraryIds'])) {
        this.promptLibraryIds = [] as any;
        for (let item of _data['promptLibraryIds']) this.promptLibraryIds!.push(item);
      }
      if (Array.isArray(_data['promptIds'])) {
        this.promptIds = [] as any;
        for (let item of _data['promptIds']) this.promptIds!.push(item);
      }
      if (Array.isArray(_data['promptOverrides'])) {
        this.promptOverrides = [] as any;
        for (let item of _data['promptOverrides']) this.promptOverrides!.push(PreviewPromptOverride.fromJS(item));
      }
    }
  }

  static fromJS(data: any): GeneratePreviewAiRequest {
    data = typeof data === 'object' ? data : {};
    let result = new GeneratePreviewAiRequest();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data['clientId'] = this.clientId;
    data['templateId'] = this.templateId;
    data['templateVersionId'] = this.templateVersionId;
    data['assessmentStrategyTypeCode'] = this.assessmentStrategyTypeCode;
    data['memberSummary'] = this.memberSummary ? this.memberSummary.toJSON() : (undefined as any);
    data['soapPayload'] = this.soapPayload ? this.soapPayload.toJSON() : (undefined as any);
    data['redactionSummary'] = this.redactionSummary ? this.redactionSummary.toJSON() : (undefined as any);
    data['runtimeOptions'] = this.runtimeOptions ? this.runtimeOptions.toJSON() : (undefined as any);
    data['optionalUserInstruction'] = this.optionalUserInstruction;
    data['correlationId'] = this.correlationId;
    data['templateContextId'] = this.templateContextId;
    if (Array.isArray(this.promptLibraryIds)) {
      data['promptLibraryIds'] = [];
      for (let item of this.promptLibraryIds) data['promptLibraryIds'].push(item);
    }
    if (Array.isArray(this.promptIds)) {
      data['promptIds'] = [];
      for (let item of this.promptIds) data['promptIds'].push(item);
    }
    if (Array.isArray(this.promptOverrides)) {
      data['promptOverrides'] = [];
      for (let item of this.promptOverrides) data['promptOverrides'].push(item ? item.toJSON() : (undefined as any));
    }
    return data;
  }
}

export interface IGeneratePreviewAiRequest {
  clientId: number;
  templateId: string;
  templateVersionId?: string | undefined;
  assessmentStrategyTypeCode: string;
  memberSummary: MemberSummaryRequest;
  soapPayload: SoapPayloadRequest;
  redactionSummary?: RedactionSummaryRequest;
  runtimeOptions?: RuntimeOptionsRequest;
  optionalUserInstruction?: string | undefined;
  correlationId?: string | undefined;
  templateContextId?: string | undefined;
  promptLibraryIds?: number[] | undefined;
  promptIds?: number[] | undefined;
  promptOverrides?: PreviewPromptOverride[] | undefined;
}

export class HealthCheckResponse implements IHealthCheckResponse {
  status?: string | undefined;
  timestamp?: string;
  version?: string | undefined;
  environment?: string | undefined;
  details?: { [key: string]: string } | undefined;

  constructor(data?: IHealthCheckResponse) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (this as any)[property] = (data as any)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.status = _data['status'];
      this.timestamp = _data['timestamp'];
      this.version = _data['version'];
      this.environment = _data['environment'];
      if (_data['details']) {
        this.details = {} as any;
        for (let key in _data['details']) {
          if (_data['details'].hasOwnProperty(key)) (this.details as any)![key] = _data['details'][key];
        }
      }
    }
  }

  static fromJS(data: any): HealthCheckResponse {
    data = typeof data === 'object' ? data : {};
    let result = new HealthCheckResponse();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data['status'] = this.status;
    data['timestamp'] = this.timestamp;
    data['version'] = this.version;
    data['environment'] = this.environment;
    if (this.details) {
      data['details'] = {};
      for (let key in this.details) {
        if (this.details.hasOwnProperty(key)) (data['details'] as any)[key] = (this.details as any)[key];
      }
    }
    return data;
  }
}

export interface IHealthCheckResponse {
  status?: string | undefined;
  timestamp?: string;
  version?: string | undefined;
  environment?: string | undefined;
  details?: { [key: string]: string } | undefined;
}

export class MemberSummaryRequest implements IMemberSummaryRequest {
  age?: number | undefined;
  sex?: string | undefined;
  lineOfBusinessLabel?: string | undefined;
  interventionTypeLabel?: string | undefined;

  constructor(data?: IMemberSummaryRequest) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (this as any)[property] = (data as any)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.age = _data['age'];
      this.sex = _data['sex'];
      this.lineOfBusinessLabel = _data['lineOfBusinessLabel'];
      this.interventionTypeLabel = _data['interventionTypeLabel'];
    }
  }

  static fromJS(data: any): MemberSummaryRequest {
    data = typeof data === 'object' ? data : {};
    let result = new MemberSummaryRequest();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data['age'] = this.age;
    data['sex'] = this.sex;
    data['lineOfBusinessLabel'] = this.lineOfBusinessLabel;
    data['interventionTypeLabel'] = this.interventionTypeLabel;
    return data;
  }
}

export interface IMemberSummaryRequest {
  age?: number | undefined;
  sex?: string | undefined;
  lineOfBusinessLabel?: string | undefined;
  interventionTypeLabel?: string | undefined;
}

export class ModelMetadataResponse implements IModelMetadataResponse {
  provider?: string | undefined;
  model?: string | undefined;
  temperature?: number | undefined;
  latencyMs?: number;
  conversationId?: string | undefined;
  responseId?: string | undefined;
  traceId?: string | undefined;
  estimatedCostUsd?: number;

  constructor(data?: IModelMetadataResponse) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (this as any)[property] = (data as any)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.provider = _data['provider'];
      this.model = _data['model'];
      this.temperature = _data['temperature'];
      this.latencyMs = _data['latencyMs'];
      this.conversationId = _data['conversationId'];
      this.responseId = _data['responseId'];
      this.traceId = _data['traceId'];
      this.estimatedCostUsd = _data['estimatedCostUsd'];
    }
  }

  static fromJS(data: any): ModelMetadataResponse {
    data = typeof data === 'object' ? data : {};
    let result = new ModelMetadataResponse();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data['provider'] = this.provider;
    data['model'] = this.model;
    data['temperature'] = this.temperature;
    data['latencyMs'] = this.latencyMs;
    data['conversationId'] = this.conversationId;
    data['responseId'] = this.responseId;
    data['traceId'] = this.traceId;
    data['estimatedCostUsd'] = this.estimatedCostUsd;
    return data;
  }
}

export interface IModelMetadataResponse {
  provider?: string | undefined;
  model?: string | undefined;
  temperature?: number | undefined;
  latencyMs?: number;
  conversationId?: string | undefined;
  responseId?: string | undefined;
  traceId?: string | undefined;
  estimatedCostUsd?: number;
}

export class PreviewPromptOverride implements IPreviewPromptOverride {
  promptId?: number;
  overrideText?: string | undefined;

  constructor(data?: IPreviewPromptOverride) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (this as any)[property] = (data as any)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.promptId = _data['promptId'];
      this.overrideText = _data['overrideText'];
    }
  }

  static fromJS(data: any): PreviewPromptOverride {
    data = typeof data === 'object' ? data : {};
    let result = new PreviewPromptOverride();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data['promptId'] = this.promptId;
    data['overrideText'] = this.overrideText;
    return data;
  }
}

export interface IPreviewPromptOverride {
  promptId?: number;
  overrideText?: string | undefined;
}

export class ProblemDetails implements IProblemDetails {
  type?: string | undefined;
  title?: string | undefined;
  status?: number | undefined;
  detail?: string | undefined;
  instance?: string | undefined;

  [key: string]: any;

  constructor(data?: IProblemDetails) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (this as any)[property] = (data as any)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      for (var property in _data) {
        if (_data.hasOwnProperty(property)) this[property] = _data[property];
      }
      this.type = _data['type'];
      this.title = _data['title'];
      this.status = _data['status'];
      this.detail = _data['detail'];
      this.instance = _data['instance'];
    }
  }

  static fromJS(data: any): ProblemDetails {
    data = typeof data === 'object' ? data : {};
    let result = new ProblemDetails();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    for (var property in this) {
      if (this.hasOwnProperty(property)) data[property] = this[property];
    }
    data['type'] = this.type;
    data['title'] = this.title;
    data['status'] = this.status;
    data['detail'] = this.detail;
    data['instance'] = this.instance;
    return data;
  }
}

export interface IProblemDetails {
  type?: string | undefined;
  title?: string | undefined;
  status?: number | undefined;
  detail?: string | undefined;
  instance?: string | undefined;

  [key: string]: any;
}

export class PromptLibraryResponse implements IPromptLibraryResponse {
  promptLibraryId?: number;
  name?: string | undefined;
  description?: string | undefined;
  isActive?: boolean;
  isDeleted?: boolean;
  promptCount?: number;

  constructor(data?: IPromptLibraryResponse) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (this as any)[property] = (data as any)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.promptLibraryId = _data['promptLibraryId'];
      this.name = _data['name'];
      this.description = _data['description'];
      this.isActive = _data['isActive'];
      this.isDeleted = _data['isDeleted'];
      this.promptCount = _data['promptCount'];
    }
  }

  static fromJS(data: any): PromptLibraryResponse {
    data = typeof data === 'object' ? data : {};
    let result = new PromptLibraryResponse();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data['promptLibraryId'] = this.promptLibraryId;
    data['name'] = this.name;
    data['description'] = this.description;
    data['isActive'] = this.isActive;
    data['isDeleted'] = this.isDeleted;
    data['promptCount'] = this.promptCount;
    return data;
  }
}

export interface IPromptLibraryResponse {
  promptLibraryId?: number;
  name?: string | undefined;
  description?: string | undefined;
  isActive?: boolean;
  isDeleted?: boolean;
  promptCount?: number;
}

export class PromptLibraryResponsePagedResult implements IPromptLibraryResponsePagedResult {
  items?: PromptLibraryResponse[] | undefined;
  readonly pageIndex?: number;
  readonly pageSize?: number;
  totalItems?: number;
  readonly totalPages?: number;
  readonly hasPreviousPage?: boolean;
  readonly hasNextPage?: boolean;

  constructor(data?: IPromptLibraryResponsePagedResult) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (this as any)[property] = (data as any)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      if (Array.isArray(_data['items'])) {
        this.items = [] as any;
        for (let item of _data['items']) this.items!.push(PromptLibraryResponse.fromJS(item));
      }
      (this as any).pageIndex = _data['pageIndex'];
      (this as any).pageSize = _data['pageSize'];
      this.totalItems = _data['totalItems'];
      (this as any).totalPages = _data['totalPages'];
      (this as any).hasPreviousPage = _data['hasPreviousPage'];
      (this as any).hasNextPage = _data['hasNextPage'];
    }
  }

  static fromJS(data: any): PromptLibraryResponsePagedResult {
    data = typeof data === 'object' ? data : {};
    let result = new PromptLibraryResponsePagedResult();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    if (Array.isArray(this.items)) {
      data['items'] = [];
      for (let item of this.items) data['items'].push(item ? item.toJSON() : (undefined as any));
    }
    data['pageIndex'] = this.pageIndex;
    data['pageSize'] = this.pageSize;
    data['totalItems'] = this.totalItems;
    data['totalPages'] = this.totalPages;
    data['hasPreviousPage'] = this.hasPreviousPage;
    data['hasNextPage'] = this.hasNextPage;
    return data;
  }
}

export interface IPromptLibraryResponsePagedResult {
  items?: PromptLibraryResponse[] | undefined;
  pageIndex?: number;
  pageSize?: number;
  totalItems?: number;
  totalPages?: number;
  hasPreviousPage?: boolean;
  hasNextPage?: boolean;
}

export class PromptMetadataResponse implements IPromptMetadataResponse {
  promptLibraryId?: number | undefined;
  promptIds?: number[] | undefined;
  clientPromptIds?: number[] | undefined;

  constructor(data?: IPromptMetadataResponse) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (this as any)[property] = (data as any)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.promptLibraryId = _data['promptLibraryId'];
      if (Array.isArray(_data['promptIds'])) {
        this.promptIds = [] as any;
        for (let item of _data['promptIds']) this.promptIds!.push(item);
      }
      if (Array.isArray(_data['clientPromptIds'])) {
        this.clientPromptIds = [] as any;
        for (let item of _data['clientPromptIds']) this.clientPromptIds!.push(item);
      }
    }
  }

  static fromJS(data: any): PromptMetadataResponse {
    data = typeof data === 'object' ? data : {};
    let result = new PromptMetadataResponse();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data['promptLibraryId'] = this.promptLibraryId;
    if (Array.isArray(this.promptIds)) {
      data['promptIds'] = [];
      for (let item of this.promptIds) data['promptIds'].push(item);
    }
    if (Array.isArray(this.clientPromptIds)) {
      data['clientPromptIds'] = [];
      for (let item of this.clientPromptIds) data['clientPromptIds'].push(item);
    }
    return data;
  }
}

export interface IPromptMetadataResponse {
  promptLibraryId?: number | undefined;
  promptIds?: number[] | undefined;
  clientPromptIds?: number[] | undefined;
}

export class PromptResponse implements IPromptResponse {
  promptId?: number;
  promptLibraryId?: number;
  name?: string | undefined;
  description?: string | undefined;
  promptText?: string | undefined;
  promptType?: string | undefined;
  sequenceNo?: number;
  isActive?: boolean;

  constructor(data?: IPromptResponse) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (this as any)[property] = (data as any)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.promptId = _data['promptId'];
      this.promptLibraryId = _data['promptLibraryId'];
      this.name = _data['name'];
      this.description = _data['description'];
      this.promptText = _data['promptText'];
      this.promptType = _data['promptType'];
      this.sequenceNo = _data['sequenceNo'];
      this.isActive = _data['isActive'];
    }
  }

  static fromJS(data: any): PromptResponse {
    data = typeof data === 'object' ? data : {};
    let result = new PromptResponse();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data['promptId'] = this.promptId;
    data['promptLibraryId'] = this.promptLibraryId;
    data['name'] = this.name;
    data['description'] = this.description;
    data['promptText'] = this.promptText;
    data['promptType'] = this.promptType;
    data['sequenceNo'] = this.sequenceNo;
    data['isActive'] = this.isActive;
    return data;
  }
}

export interface IPromptResponse {
  promptId?: number;
  promptLibraryId?: number;
  name?: string | undefined;
  description?: string | undefined;
  promptText?: string | undefined;
  promptType?: string | undefined;
  sequenceNo?: number;
  isActive?: boolean;
}

export class RedactionSummaryRequest implements IRedactionSummaryRequest {
  redactedFieldCount?: number;
  redactedRuleIds?: string[] | undefined;

  constructor(data?: IRedactionSummaryRequest) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (this as any)[property] = (data as any)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.redactedFieldCount = _data['redactedFieldCount'];
      if (Array.isArray(_data['redactedRuleIds'])) {
        this.redactedRuleIds = [] as any;
        for (let item of _data['redactedRuleIds']) this.redactedRuleIds!.push(item);
      }
    }
  }

  static fromJS(data: any): RedactionSummaryRequest {
    data = typeof data === 'object' ? data : {};
    let result = new RedactionSummaryRequest();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data['redactedFieldCount'] = this.redactedFieldCount;
    if (Array.isArray(this.redactedRuleIds)) {
      data['redactedRuleIds'] = [];
      for (let item of this.redactedRuleIds) data['redactedRuleIds'].push(item);
    }
    return data;
  }
}

export interface IRedactionSummaryRequest {
  redactedFieldCount?: number;
  redactedRuleIds?: string[] | undefined;
}

export class RuntimeOptionsRequest implements IRuntimeOptionsRequest {
  agentName?: string | undefined;
  modelName?: string | undefined;
  temperature?: number | undefined;

  constructor(data?: IRuntimeOptionsRequest) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (this as any)[property] = (data as any)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.agentName = _data['agentName'];
      this.modelName = _data['modelName'];
      this.temperature = _data['temperature'];
    }
  }

  static fromJS(data: any): RuntimeOptionsRequest {
    data = typeof data === 'object' ? data : {};
    let result = new RuntimeOptionsRequest();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data['agentName'] = this.agentName;
    data['modelName'] = this.modelName;
    data['temperature'] = this.temperature;
    return data;
  }
}

export interface IRuntimeOptionsRequest {
  agentName?: string | undefined;
  modelName?: string | undefined;
  temperature?: number | undefined;
}

export class SaveClientAiConfigRequest implements ISaveClientAiConfigRequest {
  isEnabled?: boolean;
  features?: ClientFeatureSettingRequest[] | undefined;
  promptLibraryIds?: number[] | undefined;
  overridePrompts?: ClientPromptOverrideRequest[] | undefined;
  featurePromptConfigurations?: ClientFeaturePromptConfigurationRequest[] | undefined;

  constructor(data?: ISaveClientAiConfigRequest) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (this as any)[property] = (data as any)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.isEnabled = _data['isEnabled'];
      if (Array.isArray(_data['features'])) {
        this.features = [] as any;
        for (let item of _data['features']) this.features!.push(ClientFeatureSettingRequest.fromJS(item));
      }
      if (Array.isArray(_data['promptLibraryIds'])) {
        this.promptLibraryIds = [] as any;
        for (let item of _data['promptLibraryIds']) this.promptLibraryIds!.push(item);
      }
      if (Array.isArray(_data['overridePrompts'])) {
        this.overridePrompts = [] as any;
        for (let item of _data['overridePrompts']) this.overridePrompts!.push(ClientPromptOverrideRequest.fromJS(item));
      }
      if (Array.isArray(_data['featurePromptConfigurations'])) {
        this.featurePromptConfigurations = [] as any;
        for (let item of _data['featurePromptConfigurations'])
          this.featurePromptConfigurations!.push(ClientFeaturePromptConfigurationRequest.fromJS(item));
      }
    }
  }

  static fromJS(data: any): SaveClientAiConfigRequest {
    data = typeof data === 'object' ? data : {};
    let result = new SaveClientAiConfigRequest();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data['isEnabled'] = this.isEnabled;
    if (Array.isArray(this.features)) {
      data['features'] = [];
      for (let item of this.features) data['features'].push(item ? item.toJSON() : (undefined as any));
    }
    if (Array.isArray(this.promptLibraryIds)) {
      data['promptLibraryIds'] = [];
      for (let item of this.promptLibraryIds) data['promptLibraryIds'].push(item);
    }
    if (Array.isArray(this.overridePrompts)) {
      data['overridePrompts'] = [];
      for (let item of this.overridePrompts) data['overridePrompts'].push(item ? item.toJSON() : (undefined as any));
    }
    if (Array.isArray(this.featurePromptConfigurations)) {
      data['featurePromptConfigurations'] = [];
      for (let item of this.featurePromptConfigurations)
        data['featurePromptConfigurations'].push(item ? item.toJSON() : (undefined as any));
    }
    return data;
  }
}

export interface ISaveClientAiConfigRequest {
  isEnabled?: boolean;
  features?: ClientFeatureSettingRequest[] | undefined;
  promptLibraryIds?: number[] | undefined;
  overridePrompts?: ClientPromptOverrideRequest[] | undefined;
  featurePromptConfigurations?: ClientFeaturePromptConfigurationRequest[] | undefined;
}

export class ClientFeaturePromptConfigurationRequest implements IClientFeaturePromptConfigurationRequest {
  featureKey!: string;
  promptLibraryIds?: number[] | undefined;
  promptIds?: number[] | undefined;
  constructor(data?: IClientFeaturePromptConfigurationRequest) {
    if (data) Object.assign(this, data);
  }
  init(_data?: any) {
    if (_data) {
      this.featureKey = _data['featureKey'];
      this.promptLibraryIds = _data['promptLibraryIds'];
      this.promptIds = _data['promptIds'];
    }
  }
  static fromJS(data: any): ClientFeaturePromptConfigurationRequest {
    const result = new ClientFeaturePromptConfigurationRequest();
    result.init(data);
    return result;
  }
  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data['featureKey'] = this.featureKey;
    data['promptLibraryIds'] = this.promptLibraryIds;
    data['promptIds'] = this.promptIds;
    return data;
  }
}

export interface IClientFeaturePromptConfigurationRequest {
  featureKey: string;
  promptLibraryIds?: number[] | undefined;
  promptIds?: number[] | undefined;
}

export class SavePromptLibraryRequest implements ISavePromptLibraryRequest {
  name!: string;
  description?: string | undefined;

  constructor(data?: ISavePromptLibraryRequest) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (this as any)[property] = (data as any)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.name = _data['name'];
      this.description = _data['description'];
    }
  }

  static fromJS(data: any): SavePromptLibraryRequest {
    data = typeof data === 'object' ? data : {};
    let result = new SavePromptLibraryRequest();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data['name'] = this.name;
    data['description'] = this.description;
    return data;
  }
}

export interface ISavePromptLibraryRequest {
  name: string;
  description?: string | undefined;
}

export class SavePromptRequest implements ISavePromptRequest {
  name!: string;
  description?: string | undefined;
  promptText!: string;
  promptType!: string;
  sequenceNo?: number;

  constructor(data?: ISavePromptRequest) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (this as any)[property] = (data as any)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.name = _data['name'];
      this.description = _data['description'];
      this.promptText = _data['promptText'];
      this.promptType = _data['promptType'];
      this.sequenceNo = _data['sequenceNo'];
    }
  }

  static fromJS(data: any): SavePromptRequest {
    data = typeof data === 'object' ? data : {};
    let result = new SavePromptRequest();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data['name'] = this.name;
    data['description'] = this.description;
    data['promptText'] = this.promptText;
    data['promptType'] = this.promptType;
    data['sequenceNo'] = this.sequenceNo;
    return data;
  }
}

export interface ISavePromptRequest {
  name: string;
  description?: string | undefined;
  promptText: string;
  promptType: string;
  sequenceNo?: number;
}

export class SoapItemRequest implements ISoapItemRequest {
  sectionId?: string | undefined;
  subsectionId?: string | undefined;
  linkId?: string | undefined;
  label?: string | undefined;
  controlType?: string | undefined;
  value?: any | undefined;

  constructor(data?: ISoapItemRequest) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (this as any)[property] = (data as any)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.sectionId = _data['sectionId'];
      this.subsectionId = _data['subsectionId'];
      this.linkId = _data['linkId'];
      this.label = _data['label'];
      this.controlType = _data['controlType'];
      this.value = _data['value'];
    }
  }

  static fromJS(data: any): SoapItemRequest {
    data = typeof data === 'object' ? data : {};
    let result = new SoapItemRequest();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data['sectionId'] = this.sectionId;
    data['subsectionId'] = this.subsectionId;
    data['linkId'] = this.linkId;
    data['label'] = this.label;
    data['controlType'] = this.controlType;
    data['value'] = this.value;
    return data;
  }
}

export interface ISoapItemRequest {
  sectionId?: string | undefined;
  subsectionId?: string | undefined;
  linkId?: string | undefined;
  label?: string | undefined;
  controlType?: string | undefined;
  value?: any | undefined;
}

export class SoapPayloadRequest implements ISoapPayloadRequest {
  subjective?: SoapItemRequest[] | undefined;
  objective?: SoapItemRequest[] | undefined;
  assessment?: SoapItemRequest[] | undefined;
  plan?: SoapItemRequest[] | undefined;

  constructor(data?: ISoapPayloadRequest) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (this as any)[property] = (data as any)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      if (Array.isArray(_data['subjective'])) {
        this.subjective = [] as any;
        for (let item of _data['subjective']) this.subjective!.push(SoapItemRequest.fromJS(item));
      }
      if (Array.isArray(_data['objective'])) {
        this.objective = [] as any;
        for (let item of _data['objective']) this.objective!.push(SoapItemRequest.fromJS(item));
      }
      if (Array.isArray(_data['assessment'])) {
        this.assessment = [] as any;
        for (let item of _data['assessment']) this.assessment!.push(SoapItemRequest.fromJS(item));
      }
      if (Array.isArray(_data['plan'])) {
        this.plan = [] as any;
        for (let item of _data['plan']) this.plan!.push(SoapItemRequest.fromJS(item));
      }
    }
  }

  static fromJS(data: any): SoapPayloadRequest {
    data = typeof data === 'object' ? data : {};
    let result = new SoapPayloadRequest();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    if (Array.isArray(this.subjective)) {
      data['subjective'] = [];
      for (let item of this.subjective) data['subjective'].push(item ? item.toJSON() : (undefined as any));
    }
    if (Array.isArray(this.objective)) {
      data['objective'] = [];
      for (let item of this.objective) data['objective'].push(item ? item.toJSON() : (undefined as any));
    }
    if (Array.isArray(this.assessment)) {
      data['assessment'] = [];
      for (let item of this.assessment) data['assessment'].push(item ? item.toJSON() : (undefined as any));
    }
    if (Array.isArray(this.plan)) {
      data['plan'] = [];
      for (let item of this.plan) data['plan'].push(item ? item.toJSON() : (undefined as any));
    }
    return data;
  }
}

export interface ISoapPayloadRequest {
  subjective?: SoapItemRequest[] | undefined;
  objective?: SoapItemRequest[] | undefined;
  assessment?: SoapItemRequest[] | undefined;
  plan?: SoapItemRequest[] | undefined;
}

export class TokenUsageResponse implements ITokenUsageResponse {
  inputTokens?: number;
  outputTokens?: number;
  totalTokens?: number;

  constructor(data?: ITokenUsageResponse) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (this as any)[property] = (data as any)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.inputTokens = _data['inputTokens'];
      this.outputTokens = _data['outputTokens'];
      this.totalTokens = _data['totalTokens'];
    }
  }

  static fromJS(data: any): TokenUsageResponse {
    data = typeof data === 'object' ? data : {};
    let result = new TokenUsageResponse();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data['inputTokens'] = this.inputTokens;
    data['outputTokens'] = this.outputTokens;
    data['totalTokens'] = this.totalTokens;
    return data;
  }
}

export interface ITokenUsageResponse {
  inputTokens?: number;
  outputTokens?: number;
  totalTokens?: number;
}

export class UpdateStatusRequest implements IUpdateStatusRequest {
  action!: string;

  constructor(data?: IUpdateStatusRequest) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (this as any)[property] = (data as any)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.action = _data['action'];
    }
  }

  static fromJS(data: any): UpdateStatusRequest {
    data = typeof data === 'object' ? data : {};
    let result = new UpdateStatusRequest();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data['action'] = this.action;
    return data;
  }
}

export interface IUpdateStatusRequest {
  action: string;
}

export class SwaggerException extends Error {
  override message: string;
  status: number;
  response: string;
  headers: { [key: string]: any };
  result: any;

  constructor(message: string, status: number, response: string, headers: { [key: string]: any }, result: any) {
    super();

    this.message = message;
    this.status = status;
    this.response = response;
    this.headers = headers;
    this.result = result;
  }

  protected isSwaggerException = true;

  static isSwaggerException(obj: any): obj is SwaggerException {
    return obj.isSwaggerException === true;
  }
}

function throwException(
  message: string,
  status: number,
  response: string,
  headers: { [key: string]: any },
  result?: any
): Observable<any> {
  if (result !== null && result !== undefined) return _observableThrow(result);
  else return _observableThrow(new SwaggerException(message, status, response, headers, null));
}

function blobToText(blob: any): Observable<string> {
  return new Observable<string>((observer: any) => {
    if (!blob) {
      observer.next('');
      observer.complete();
    } else {
      let reader = new FileReader();
      reader.onload = (event) => {
        observer.next((event.target as any).result);
        observer.complete();
      };
      reader.readAsText(blob);
    }
  });
}
